import { Link } from "gatsby"
import React from "react"
import logo from "../assets/images/logo.png"
import styled from "styled-components"

const StyledHeader = styled.header`
  position: sticky;
  top: 0;
  background-color: ${({ pageScrolled, theme }) =>
    pageScrolled ? "rgba(21, 22, 27, 0.8)" : theme.colors.obsidian};
  padding: ${({ pageScrolled }) =>
    pageScrolled ? "0.5rem 1rem" : "1rem 1rem"};
  z-index: 2;
  width: 100%;
  transition: all 0.4s ease-in-out;
  .logo {
    max-width: 180px;
    a {
      display: block;
    }
    img {
      display: block;
      max-width: 100%;
    }
  }
  @media only screen and (min-width: 500px) {
    padding-left: 2rem;
    padding-right: 2rem;
    .logo {
      max-width: 220px;
    }
  }
`

const Header = ({ siteTitle, pageScrolled }) => (
  <StyledHeader pageScrolled={pageScrolled}>
    <div className="logo">
      <Link to="/">
        <img src={logo} alt={siteTitle} />
      </Link>
    </div>
  </StyledHeader>
)

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
